import { AuthenticationStore, AuthenticationState } from './authentication.store';
import { Injectable } from '@angular/core';
import { TokenInfo } from '../interfaces/token-info.interface';
import { AuthenticationToken, UserRoles } from '../constants/authentication.constants';
import { Router } from '@angular/router';
import { SharedUrls } from '../../shared/constants/shared.constants';
import { UserInfo } from '../interfaces/user-info.interface';
import { AuthenticationQuery } from './authentication.query';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  constructor(private authenticationStore: AuthenticationStore,
    public authenticationQuery: AuthenticationQuery,
    private router: Router) { }

  login(tokenInfo: TokenInfo) {
    localStorage.setItem(AuthenticationToken.TokenInfo, JSON.stringify(tokenInfo));
  }

  logout() {
    localStorage.removeItem(UserRoles.Roles);
    localStorage.removeItem(AuthenticationToken.TokenInfo);
    this.router.navigate([SharedUrls.Login]);
  }

  updateAuthenticationState(authenticationState: Partial<AuthenticationState>) {
    this.authenticationStore.update(() => authenticationState);
  }

  clearAuthenticationState() {
    this.authenticationStore.reset();
  }


  public get roles(): string[] {
    return this.authenticationQuery.roles;
  }

}
